import * as React from "react";
const SvgExpandText = (props) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 18, viewBox: "0 0 19 18", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.5 14V9H6V12.5H9.5V14H4.5ZM13 9V5.5H9.5V4H14.5V9H13Z" }));
export default SvgExpandText;
